//
import Tamanho from '../../shared/entity/Tamanho';
import { formatarDinheiro } from '../../shared/helper';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { RadioButton } from 'react-native-paper';
import { TXT_M, TXT_P } from '../../constants';
import Touchable from '../Generic/Touchable';
import colors from '../../colors';

type Props = {
  tamanho: Tamanho;
  onPress: (tamanho: Tamanho) => void;
  selecionado: boolean;
};

const ItemTamanho: React.FC<Props> = (props) => {
  const { tamanho, onPress, selecionado } = props;

  return (
    <Touchable
      onPress={() => onPress(tamanho)}
      style={{
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <RadioButton
          value=""
          status={selecionado === true ? 'checked' : 'unchecked'}
          onPress={() => onPress(tamanho)}
          // onChange={() => onPress(adicional)}
        />
        <Text style={{ fontSize: TXT_M, fontWeight: '600' }}>{tamanho.descricao}</Text>
      </View>

      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Text
          style={{
            fontSize: tamanho.precoPromocional > 0 ? TXT_P : TXT_M,
            fontWeight: '600',
            textDecorationLine: tamanho.precoPromocional > 0 ? 'line-through' : undefined,
            color: tamanho.precoPromocional > 0 ? colors.darkGrey : '#000'
          }}
        >
          R${formatarDinheiro(tamanho.preco)}
        </Text>
        {tamanho.precoPromocional > 0 && (
          <Text
            style={{
              fontSize: TXT_M,
              fontWeight: '600',
              marginLeft: 5
            }}
          >
            R${formatarDinheiro(tamanho.precoPromocional)}
          </Text>
        )}
      </View>
    </Touchable>
  );
};

const styles = StyleSheet.create({});

export default ItemTamanho;
